export enum OrderStatus {
    ORDER_CREATED = 'ORDER_CREATED',
    PAYMENT_INITIATED_BY_CUSTOMER = 'PAYMENT_INITIATED_BY_CUSTOMER',
    PAYMENT_INITIATED_BY_DEALER = 'PAYMENT_INITIATED_BY_DEALER',
    ORDER_LINK_EXPIRED = 'ORDER_LINK_EXPIRED',
    PAYMENT_SUCCESS_BY_DEALER = 'PAYMENT_SUCCESS_BY_DEALER',
    POLICY_CREATED = 'POLICY_CREATED',
    PAYMENT_FAILED = 'PAYMENT_FAILED',
    PAYMENT_SUCCESS_BY_CUSTOMER = 'PAYMENT_SUCCESS_BY_CUSTOMER',
    CUSTOMER_LINK_SHARED = 'CUSTOMER_LINK_SHARED',
}
